import AboutUs from "./AboutUs";

const About = () => {
  return (
    <section className="p-3 p-sm-5">
      <p className="title mb-4 mb-lg-5">About Us</p>
      <AboutUs/>
    </section>
  )
}

export default About
